// extracted by mini-css-extract-plugin
export default {"requestsByUser":"RequestListView_requestsByUser__zTTHp"};